import NotificationsOutlet from "./notifications-outlet-container";

export default NotificationsOutlet;
